<div
	class="u-shadow-mini pos-relative {{ currentPageClass }} r9-{{ sectionclass }} "
	[ngClass]="{ 'social-video-creative': currentCreativeData?.showStats, entravision: isEntravisionR103 }"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet_box_specs" [ngClass]="{ 'no-data': !hasData }">
		<div *ngIf="!hasData">
			<div class="creative-title primary-color">
				<h5>{{ sectiontitle }}</h5>
			</div>
			<div class="parameters-div" style="padding: 15px 20px">
				<span class="no-data-message">No Data to Display</span>
			</div>
		</div>

		<div *ngIf="hasData">
			<div class="creative-title primary-color">
				<span *ngIf="!isR9 && overviewTitle && !isOverviewSem"
					>{{ sectiontitle }} {{ selectedIndex + 1 }}: {{ currentCreativeData?.creativeName }}</span
				>
				<span *ngIf="!isR9 && overviewTitle && isOverviewSem"
					>{{ sectiontitle }} {{ selectedIndex + 1 }}: {{ currentCreativeData?.adHeadline }}</span
				>
				<span *ngIf="isR9 && overviewTitle && !isOverviewSem"
					>{{ sectiontitle }}: {{ currentCreativeData?.creativeName }}</span
				>
				<span *ngIf="isR9 && overviewTitle && isOverviewSem"
					>{{ sectiontitle }}: {{ currentCreativeData?.adHeadline }}</span
				>
				<span *ngIf="!overviewTitle">{{ sectiontitle }}: {{ currentCreativeData?.creativeName }}</span> &nbsp; &nbsp;
				<span *ngIf="downloadConfiguration.enableDownload">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadDataInCSV($event)"
						target="_blank"
					>
						<img src="../../../../../assets/creative-assets/download.svg" />
					</a>
				</span>
			</div>
			<div class="stats-divTop" *ngIf="graphData">
				<div *ngFor="let stat of currentCreativeStats" class="inline inline{{ currentCreativeStats.length }}">
					<div class="param-name">{{ stat.name | titlecase }}</div>
					<div class="param-val">{{ stat.value }}</div>
				</div>
				<br class="clearBoth" />
			</div>
			<div class="carousel-area">
				<div class="creative-performance-stats sem-{{ sectionclass }}">
					<div class="creative-carousel" *ngIf="sortedCreatives?.length > 0">
						<span
							(click)="slideLeft()"
							class="u-cursor-pointer u-cursor-pointer-left"
							*ngIf="sortedCreatives?.length > 1"
						>
							<img *ngIf="!isR11" src="../../../../../assets/creative-assets/left_arrow.svg" [class]="arrowClass" />
							<div *ngIf="isR11" [class]="arrowClass">
								<img style="position: relative; left: 25%" src="../../../../../assets/images/left_arrow.png" />
							</div>
						</span>
						<ngx-carousel-3d
							[slides]="sortedCreatives"
							[slideClass]="sectionclass"
							[options]="options"
							[ngClass]="['carouselClass', sectionclass]"
							#carousel
						>
							<ngx-carousel-3d-slide
								*ngFor="let sortedCreative of sortedCreatives; let i = index"
								(click)="slideClicked(i)"
								style="height: 300px"
								class="carouselSlide"
							>
								<div class="slideMask"></div>
								<div
									class="sem-creative-card"
									style="height: inherit; overflow: auto"
									*ngIf="
										!sortedCreative.isDisplay &&
											!sortedCreative.isSocial &&
											!sortedCreative.isCtv &&
											!sortedCreative.isRadio &&
											!sortedCreative.isPreRoll;
										else DisplayCreatives
									"
								>
									<div class="sem-creative-card-inner-div">
										<h4 class="sem-creative-heading">{{ sortedCreative?.adHeadline }}</h4>
										<div class="sem-creative-card-link-container">
											<span class="sem-creative-card-text">AD</span>
											<cite class="sem-creative-card-link">{{ sortedCreative?.url }}</cite>
										</div>
										<span class="sem-creative-card-roboto">{{ sortedCreative?.callExtension }}</span>
										<div
											*ngIf="isTypeString(sortedCreative?.description); else elseBlock"
											class="sem-creative-card-description sem-creative-card-roboto"
										>
											{{ sortedCreative?.description }}
										</div>
										<ng-template #elseBlock>
											<div class="sem-creative-card-description sem-creative-card-roboto">
												<p *ngFor="let desc of sortedCreative?.description">{{ desc }}.</p>
											</div>
										</ng-template>
										<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
											<div>
												<p>
													<span
														class="sem-creative-card-roboto"
														*ngFor="let callout of sortedCreative?.calloutsExtn; let i = index"
														>{{ callout
														}}<span [ngClass]="{ last_callout_class: i == sortedCreative?.calloutsExtn.length - 1 }">
															&middot;
														</span></span
													>
												</p>
											</div>
										</div>
										<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
											<div *ngFor="let snippet of sortedCreative?.structuredSnippetExtn">
												<p class="sem-creative-card-roboto">{{ snippet?.type }}: {{ snippet?.value }}</p>
											</div>
										</div>
										<div class="sem-creative-card-siteLinks-container">
											<div *ngFor="let siteLink of sortedCreative?.siteLinks" class="sem-creative-card-sitelinks">
												<h4>
													<a href="{{ siteLink?.link }}" target="_blank">{{ siteLink?.heading }}</a>
												</h4>
												<span class="sem-creative-card-roboto">{{ siteLink?.description }}</span>
											</div>
										</div>
										<div
											*ngIf="
												sortedCreative &&
												sortedCreative.location &&
												sortedCreative.location.trim().split(',').length > 0
											"
										>
											<span
												[ngStyle]="{ color: !last ? '#1a0dab' : '#4a4a4a' }"
												*ngFor="let location of sortedCreative.location.split(','); let last = last; let first = first"
												class="sem-creative-card-location"
											>
												<i class="fa fa-map-marker" aria-hidden="true" *ngIf="first" style="color: #575757"></i>
												{{ location }}<span *ngIf="!last">,</span></span
											>
										</div>
									</div>
								</div>
								<ng-template #DisplayCreatives>
									<div class="display-creative-card">
										<!--		Display Creatives Starts Here		-->
										<div
											class="display_creative_img"
											*ngIf="!sortedCreative.isVideoCreative && !sortedCreative.isRadio"
										>
											<img
												*ngIf="sortedCreative?.creativeThumbnail; else noCreativeThumbnail"
												(click)="openModal('custom-modal-creative-preview', sortedCreative)"
												[src]="sortedCreative?.creativeThumbnail"
												class="creativeImg"
												[ngClass]="{
													c728x90:
														sortedCreative.creativeThumbnail.includes('728x90') ||
														sortedCreative.creativeThumbnail.includes('320x50') ||
														sortedCreative.creativeThumbnail.includes('300x50') ||
														sortedCreative.creativeThumbnail.includes('468x60'),
													c160x600: sortedCreative.creativeThumbnail.includes('160x600')
												}"
											/>
											<ng-template #noCreativeThumbnail>
												<img
													*ngIf="sortedCreative?.creativeThumbnail"
													(click)="openModal('custom-modal-creative-preview', sortedCreative)"
													[src]="defaultCreativeThumbnail.image"
													class="creativeImg"
													[ngClass]="{
														c728x90:
															sortedCreative.creativeThumbnail.includes('728x90') ||
															sortedCreative.creativeThumbnail.includes('320x50') ||
															sortedCreative.creativeThumbnail.includes('300x50') ||
															sortedCreative.creativeThumbnail.includes('468x60'),
														c160x600: sortedCreative.creativeThumbnail.includes('160x600')
													}"
												/>
												<img
													*ngIf="!sortedCreative?.creativeThumbnail && !sortedCreative.isSocial"
													[src]="placeholderimage"
													class="backgroundSlideImage placeholder"
												/>
												<img
													*ngIf="!sortedCreative?.creativeThumbnail && sortedCreative.isSocial"
													class="card-long-img social-creative-placeholder-img"
													[ngStyle]="{
														background: 'url(' + placeholderimage + ') no-repeat center center',
														'background-size': getCreativeSize(sortedCreative.creativeThumbnail)
													}"
												/>
											</ng-template>
										</div>
										<!--		Display Creatives Ends Here		-->
										<!--	Video Creatives Starts Here		-->
										<div *ngIf="sortedCreative.isVideoCreative && !sortedCreative.isRadio">
											<div *ngIf="isActiveSlide(i) && sortedCreative.creativeVideo; else elseBlock">
												<div class="ShowControls" style="top: 4%">
													<video
														class=""
														*ngIf="!sortedCreative.isSocial && sortedCreative.creativeVideo; else elseBlock"
														[hidden]="showLoad"
														style="width: 100%; margin-top: 14px"
														[id]="sectionclass"
														[muted]="'muted'"
														autoplay
														#videoName
														[src]="sortedCreative.creativeVideo"
													>
														<source type="video/mp4" />
														Your browser does not support HTML5 video.
													</video>
													<div
														*ngIf="sortedCreative.isIframeExpired == 0 && sortedCreative.isSocial"
														class="social-thumbnail"
														[innerHtml]="sortedCreative.iframeUrl | safeUrl : false"
													></div>
												</div>
												<div class="showIconsControls">
													<span class="playVideo" (click)="playclickEvent($event)">
														<img [id]="playBtn" class="volumeClass" src="./assets/images/play.png" />
													</span>
													<span class="playVideo" (click)="pauseclickEvent($event)">
														<img [id]="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
													</span>
												</div>
												<div class="volumecontrols" [hidden]="showLoad">
													<span *ngIf="!isMuted" id="volumeBtn" class="volumeControlIcon" (click)="volumeclick($event)">
														<!--<i class="volumecontrols fa fa-volume-up"></i>-->
														<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
														<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
													</span>
													<span *ngIf="isMuted" id="muteBtn" class="volumeControlIcon" (click)="muteclick($event)">
														<!--<i class="volumecontrols fa fa-volume-off"></i>-->
														<span class="VolumeControlHoverClass">UNMUTE</span>
														<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
													</span>
												</div>
											</div>
											<ng-template #elseBlock>
												<img
													[src]="
														!sortedCreative?.creativeThumbnail || sortedCreative?.creativeThumbnail === 'null'
															? placeholderimage
															: sortedCreative?.creativeThumbnail
													"
													[ngClass]="{
														placeholder:
															!sortedCreative?.creativeThumbnail || sortedCreative?.creativeThumbnail === 'null'
													}"
													class="backgroundSlideImage"
												/>
											</ng-template>
										</div>
										<!--	Video Creatives Ends Here		-->
										<!--		Audio Creatives Starts Here		-->
										<div *ngIf="sortedCreative.isRadio && sortedCreative.audioURL">
											<div *ngIf="isActiveSlide(i); else audioElseBlock">
												<div>
													<audio
														class=""
														*ngIf="!sortedCreative.isSocial"
														[hidden]="showLoad"
														style="width: 100%; margin-top: 14px"
														[id]="sectionclass"
														[muted]="'muted'"
														autoplay
														#videoName
														[src]="sortedCreative.audioURL"
													>
														<source type="video/mp3" />
														Your browser does not support HTML5 audio.
													</audio>
													<div
														*ngIf="sortedCreative.isIframeExpired == 0 && sortedCreative.isSocial"
														class="social-thumbnail"
														[innerHtml]="sortedCreative.iframeUrl | safeUrl : false"
													></div>
												</div>
												<ng-container *ngIf="isR11">
													<div class="audio-thumbnail">
														<svg xmlns="http://www.w3.org/2000/svg" width="71" height="92" viewBox="0 0 71 92">
															<path
																class="secondary-svg-fill"
																fill="#cccccc"
																fill-rule="evenodd"
																d="M5.736 60.065l4.427 1.593C6.938 65.552 5 70.55 5 76c0 5.45 1.938 10.448 5.162 14.342l-4.426 1.593C2.153 87.61 0 82.056 0 76c0-6.056 2.153-11.61 5.736-15.935zM47.841 0c.105 0 .21.017.31.05L70.114 7.21c.499.163.787.684.66 1.193l-2.428 9.71c-.134.537-.677.862-1.212.729-.113-.029-.22-.077-.317-.142L49.559 7.053c-.457-.31-1.079-.189-1.388.269-.111.165-.171.36-.171.56l.001 61.484C49.264 71.266 50 73.547 50 76c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12c2.186 0 4.236.585 6.001 1.606L44 1c0-.552.448-1 1-1h2.841zm-29.71 64.526l4.426 1.593C20.335 68.802 19 72.245 19 76s1.335 7.198 3.557 9.88l-4.427 1.594C15.55 84.359 14 80.36 14 76s1.55-8.359 4.13-11.474z"
															/>
														</svg>
														<svg
															class="audio-icon-r1101"
															width="113"
															height="113"
															viewBox="0 0 113 113"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M71.0693 46.1333C71.0693 45.7028 70.8652 45.2978 70.519 45.0413C70.1728 44.7849 69.7254 44.7073 69.3129 44.8323L69.2462 44.8525L69.2403 44.833L48.3673 51.1769L48.3658 51.1777C47.7926 51.3519 47.4008 51.8799 47.4008 52.4783L47.4008 68.7931H41.9555C36.5923 68.7931 32.9504 76.2255 37.8166 81.0842C42.3121 85.5729 50.1235 82.2306 50.1235 76.0441L50.1235 53.4864L68.3467 47.9664L68.3467 64.2608H62.9013C57.5381 64.2608 53.8963 71.6932 58.7624 76.5519C63.2579 81.0406 71.0693 77.6983 71.0693 71.5118L71.0693 46.1333ZM62.9013 66.9799H68.3467L68.3467 71.5118C68.3467 75.2954 63.4539 77.3913 60.6874 74.629C57.4411 71.3876 60.0984 66.9799 62.9013 66.9799ZM41.9555 71.5122H47.4008V76.0441C47.4008 79.8277 42.508 81.9236 39.7416 79.1613C36.4953 75.9199 39.1526 71.5122 41.9555 71.5122Z"
																class="primary-svg-fill"
															/>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M3.55346 0C1.59094 0 0 1.59093 0 3.55346V109.447C0 111.409 1.59093 113 3.55346 113H109.447C111.409 113 113 111.409 113 109.447V3.55346C113 1.59094 111.409 0 109.447 0H3.55346ZM67.1205 36.6063C67.3336 36.9938 67.5192 37.3563 67.6791 37.6856C68.5934 37.2741 69.8179 36.8128 71.2555 36.4933C74.4691 35.7792 78.8339 35.7638 83.086 38.6886C86.9517 41.3477 88.5532 45.1055 89.1915 48.0973C89.5108 49.5943 89.5963 50.9265 89.6024 51.8878C89.6031 51.99 89.6028 52.0882 89.6019 52.1822C89.6683 52.2138 89.7371 52.2468 89.8082 52.2812C90.6283 52.6775 91.759 53.2589 93.009 54.0029C95.4672 55.4661 98.5596 57.6584 100.575 60.43C103.807 64.8737 104.697 72.1349 102.885 78.237C101.965 81.3328 100.318 84.254 97.7926 86.4107C95.2446 88.5868 91.8977 89.9009 87.7646 89.9009H27.0013C13.968 89.9009 7.37633 78.4319 7.82004 68.855C8.20488 60.5491 12.5856 55.3031 16.7959 52.1897C18.8908 50.6405 20.9543 49.6076 22.4928 48.961C22.9852 48.754 23.4263 48.5856 23.8004 48.4517C23.8147 48.028 23.8441 47.5201 23.8997 46.9445C24.0662 45.2204 24.4703 42.8611 25.4272 40.3254C27.3596 35.2049 31.544 29.4049 40.3415 26.7264C50.9918 23.4837 58.1283 26.5946 62.5513 30.6994C64.7176 32.7098 66.1903 34.9146 67.1205 36.6063Z"
																class="primary-svg-fill"
															/>
														</svg>
														<svg
															class="audio-icon-r1102"
															width="125"
															height="97"
															viewBox="0 0 125 97"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M104.469 52.3599C104.469 75.5943 85.6786 94.4295 62.5 94.4295C56.3723 94.4295 50.5513 93.113 45.3028 90.7467L24.3645 97L29.7958 78.7273C24.0007 71.5137 20.5314 62.3429 20.5314 52.3599C20.5314 29.1256 39.3214 10.2904 62.5 10.2904C85.6786 10.2904 104.469 29.1256 104.469 52.3599ZM49.5169 32.9898C49.5169 25.8022 55.3297 19.9755 62.5 19.9755C69.6703 19.9755 75.4831 25.8022 75.4831 32.9898V46.9121C75.4831 54.0996 69.6703 59.9264 62.5 59.9264C55.3297 59.9264 49.5169 54.0996 49.5169 46.9121V32.9898ZM43.1763 36.319C44.3434 36.319 45.2899 37.2675 45.2899 38.4376V47.5174C45.2899 57.0452 52.995 64.7689 62.5 64.7689C72.005 64.7689 79.7101 57.0452 79.7101 47.5174V38.4376C79.7101 37.2675 80.6566 36.319 81.8237 36.319C82.9907 36.319 83.9372 37.2675 83.9372 38.4376V47.5174C83.9372 58.6702 75.4613 67.839 64.6135 68.903V79.9019H70.9541C72.1211 79.9019 73.0676 80.8503 73.0676 82.0205C73.0676 83.1906 72.1211 84.1391 70.9541 84.1391H53.442C52.275 84.1391 51.3285 83.1906 51.3285 82.0205C51.3285 80.8503 52.275 79.9019 53.442 79.9019H59.7826V68.835C49.2262 67.4964 41.0628 58.4625 41.0628 47.5174V38.4376C41.0628 37.2675 42.0093 36.319 43.1763 36.319Z"
																fill="#21409A"
															/>
															<path
																d="M115.942 44.7935H115.786C111.48 19.3636 89.3967 0 62.8019 0C36.2071 0 14.1242 19.3636 9.81811 44.7935H9.05797C6.05634 44.7935 3.62319 47.2325 3.62319 50.2413V76.8753C3.62319 79.8841 6.05634 82.3231 9.05797 82.3231H13.8889C16.8905 82.3231 19.3237 79.8841 19.3237 76.8753V50.2413C19.3237 47.307 17.0091 44.9146 14.1106 44.7979C18.3648 21.7184 38.5465 4.23722 62.8019 4.23722C87.0556 4.23722 107.236 21.7163 111.492 44.7935H111.111C108.109 44.7935 105.676 47.2325 105.676 50.2413V76.8753C105.676 79.8841 108.109 82.3231 111.111 82.3231H115.942C118.944 82.3231 121.377 79.8841 121.377 76.8753V50.2413C121.377 47.2325 118.944 44.7935 115.942 44.7935Z"
																fill="#0E0606"
															/>
															<path
																d="M121.377 78.0431C123.425 77.7493 125 75.9836 125 73.8487V55.0839C125 52.949 123.425 51.1833 121.377 50.8895V78.0431Z"
																fill="#21409A"
															/>
															<path
																d="M3.62319 78.0429C1.5747 77.7492 0 75.9833 0 73.8486V55.0838C0 52.9492 1.5747 51.1832 3.62319 50.8895V78.0429Z"
																fill="#21409A"
															/>
														</svg>
													</div>
												</ng-container>
												<ng-container *ngIf="isR9">
													<div class="audio-thumbnail">
														<svg
															width="110"
															height="110"
															viewBox="0 0 110 110"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g clip-path="url(#or44er1baa)" fill="#00588E">
																<path
																	d="M55 0a55 55 0 1 0 0 110A55 55 0 0 0 55 0zm0 107.25A52.247 52.247 0 0 1 6.727 74.995 52.25 52.25 0 1 1 55 107.25z"
																/>
																<path
																	d="M55 5.5a49.5 49.5 0 1 0 0 98.999A49.5 49.5 0 0 0 55 5.5zM23.457 70.29c-.23.17-.51.26-.797.258a1.36 1.36 0 0 1-1.1-.582c-11.55-16.236-.044-29.986.077-30.124a1.375 1.375 0 0 1 2.084 1.788c-.418.494-10.197 12.292.078 26.746a1.368 1.368 0 0 1-.341 1.914zm3.757-4.053a1.375 1.375 0 0 1-1.914-.325c-8.426-11.853 0-21.912.077-22a1.375 1.375 0 0 1 2.085 1.793c-.303.358-7.073 8.569.076 18.629a1.375 1.375 0 0 1-.324 1.903zm3.658-3.592a1.37 1.37 0 0 1-.798.253 1.354 1.354 0 0 1-1.1-.55c-4.538-6.374-1.936-12.49.072-14.85a1.376 1.376 0 0 1 2.09 1.788c-.193.23-4.313 5.28.076 11.456a1.37 1.37 0 0 1-.34 1.903zm42.184 22.083a3.025 3.025 0 0 1-3.025 3.025H40.216a3.025 3.025 0 0 1-3.025-3.025V25.179a3.031 3.031 0 0 1 3.025-3.025h29.815a3.03 3.03 0 0 1 3.025 3.025v59.549zm6.82-21.83a1.375 1.375 0 0 1-1.045-2.266c.188-.22 4.323-5.269-.071-11.451a1.375 1.375 0 1 1 2.239-1.595c4.537 6.38 1.936 12.49-.078 14.85a1.358 1.358 0 0 1-1.045.462zm3.658 3.592a1.375 1.375 0 0 1-1.045-2.266c.291-.347 7.084-8.564-.072-18.635a1.375 1.375 0 0 1 2.239-1.594c8.426 11.852 0 21.917-.077 22a1.357 1.357 0 0 1-1.045.495zm4.801 3.575a1.375 1.375 0 0 1-2.084-1.788c.423-.5 10.197-12.293-.077-26.746a1.376 1.376 0 1 1 2.238-1.59c11.545 16.236.044 29.992-.077 30.123z"
																/>
																<path
																	d="M70.031 24.904H40.216a.28.28 0 0 0-.275.275v54.373h30.365V25.179a.28.28 0 0 0-.275-.275zm-14.91 2.805a2.42 2.42 0 1 1 0 4.84 2.42 2.42 0 0 1 0-4.84zm7.942 30.75a.954.954 0 0 1 0 .127v.253a2.954 2.954 0 1 1-1.991-2.794v-6.826a.192.192 0 0 0-.072-.148.186.186 0 0 0-.164-.044l-7.877 1.386a.203.203 0 0 0-.159.187v9.031a.954.954 0 0 1 0 .127v.247a2.954 2.954 0 1 1-2.953-2.954c.327.001.653.057.962.166V50.6a2.2 2.2 0 0 1 1.81-2.162l7.881-1.375a2.202 2.202 0 0 1 2.569 2.156l-.006 9.24z"
																/>
															</g>
															<defs>
																<clipPath id="or44er1baa">
																	<path fill="#fff" d="M0 0h110v110H0z" />
																</clipPath>
															</defs>
														</svg>
													</div>
												</ng-container>
												<ng-container *ngIf="!isR11 && !isR9">
													<div class="audio-thumbnail">
														<svg
															width="90px"
															height="98px"
															viewBox="0 0 90 98"
															version="1.1"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<path
																	class="secondary-svg-fill"
																	fill="#cccccc"
																	d="M70.265038,-1.98951966e-13 C82.5065659,12.9069993 89.5,30.3401707 89.5,48.9148779 C89.5,67.2602677 82.6781774,84.4921338 70.716025,97.3496556 L70.265038,97.8297558 L63.734962,91.6363636 C74.3950845,80.3967377 80.5,65.1784577 80.5,48.9148779 C80.5,32.8803626 74.5658429,17.8619094 64.1826745,6.67066551 L63.734962,6.19339216 L70.265038,-1.98951966e-13 Z M35.4427746,9.22224999 C35.8003326,9.59470616 36,10.0910083 36,10.6073137 L36,87.2224421 C36,88.3270116 35.1045695,89.2224421 34,89.2224421 C33.4836946,89.2224421 32.9873925,89.0227747 32.6149363,88.6652168 L11,67.9148779 L-1.13686838e-13,67.9148779 L-1.13686838e-13,29.9148779 L11,29.9148779 L32.6149363,9.16453901 C33.4117588,8.39958947 34.6778251,8.42542756 35.4427746,9.22224999 Z M56.265038,17.8181818 C64.0534672,26.030004 68.5,37.1142821 68.5,48.9148779 C68.5,60.5154636 64.2029198,71.4238078 56.6581744,79.5915587 L56.265038,80.011574 L49.734962,73.8181818 C55.9419858,67.273733 59.5,58.4043463 59.5,48.9148779 C59.5,39.6078992 56.0775167,30.8973824 50.090114,24.3917057 L49.734962,24.011574 L56.265038,17.8181818 Z M43.9099026,33.0049753 C48.0993194,37.1943922 50.5,42.8702386 50.5,48.9148779 C50.5,54.8084013 48.217853,60.3513408 44.2207454,64.5078046 L43.9099026,64.8247805 L37.5459415,58.4608194 C40.0642628,55.9424982 41.5,52.5480342 41.5,48.9148779 C41.5,45.4070028 40.161572,42.1216424 37.8025813,39.6325516 L37.5459415,39.3689364 L43.9099026,33.0049753 Z"
																></path>
															</g>
														</svg>
													</div>
												</ng-container>
												<div class="showAudioIconsControls">
													<span class="audioControlIcon" (click)="playclickEvent($event)">
														<span [id]="playTxt" class="MediaControlHoverClass">PLAY</span>
														<svg
															[id]="playBtn"
															class="audioControls"
															xmlns="http://www.w3.org/2000/svg"
															viewBox="0 0 24 24"
														>
															<g fill="none" fill-rule="evenodd">
																<path fill="#2E2E2E" d="M8 5L8 19 19 12z" />
																<path d="M0 0L24 0 24 24 0 24z" />
															</g>
														</svg>
													</span>
													<span class="audioControlIcon" (click)="pauseclickEvent($event)">
														<span [id]="pauseTxt" class="MediaControlHoverClass">PAUSE</span>
														<svg
															[id]="pauseBtn"
															class="audioControls"
															xmlns="http://www.w3.org/2000/svg"
															viewBox="0 0 24 24"
														>
															<g fill="none" fill-rule="evenodd">
																<path fill="#2E2E2E" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
																<path d="M0 0L24 0 24 24 0 24z" />
															</g>
														</svg>
													</span>
												</div>
												<div class="audioVolumecontrols" [hidden]="showLoad">
													<span *ngIf="!isMuted" id="volumeBtn" class="volumeControlIcon" (click)="volumeclick($event)">
														<span class="AudioVolumeControlHoverClass">MUTE&nbsp;&nbsp;&nbsp;</span>
														<svg
															[id]="mutebtn"
															class="audioControls"
															xmlns="http://www.w3.org/2000/svg"
															viewBox="0 0 24 24"
														>
															<g fill="none" fill-rule="evenodd">
																<path d="M0 0L24 0 24 24 0 24z" />
																<path
																	fill="#2E2E2E"
																	fill-rule="nonzero"
																	d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
																/>
															</g>
														</svg>
													</span>
													<span *ngIf="isMuted" id="muteBtn" class="volumeControlIcon" (click)="muteclick($event)">
														<span class="AudioVolumeControlHoverClass">UNMUTE</span>
														<svg
															[id]="volumebtn"
															class="audioControls"
															xmlns="http://www.w3.org/2000/svg"
															viewBox="0 0 24 24"
														>
															<g fill="none" fill-rule="evenodd">
																<path
																	fill="#2E2E2E"
																	d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
																/>
																<path d="M0 0L24 0 24 24 0 24z" />
															</g>
														</svg>
													</span>
												</div>
											</div>
											<ng-template #audioElseBlock>
												<ng-container *ngIf="isR11">
													<div class="audio-thumbnail">
														<svg
															class="audio-thumbnail-unselected"
															xmlns="http://www.w3.org/2000/svg"
															width="71"
															height="92"
															viewBox="0 0 71 92"
														>
															<path
																class="secondary-svg-fill"
																fill="#cccccc"
																fill-rule="evenodd"
																d="M5.736 60.065l4.427 1.593C6.938 65.552 5 70.55 5 76c0 5.45 1.938 10.448 5.162 14.342l-4.426 1.593C2.153 87.61 0 82.056 0 76c0-6.056 2.153-11.61 5.736-15.935zM47.841 0c.105 0 .21.017.31.05L70.114 7.21c.499.163.787.684.66 1.193l-2.428 9.71c-.134.537-.677.862-1.212.729-.113-.029-.22-.077-.317-.142L49.559 7.053c-.457-.31-1.079-.189-1.388.269-.111.165-.171.36-.171.56l.001 61.484C49.264 71.266 50 73.547 50 76c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12c2.186 0 4.236.585 6.001 1.606L44 1c0-.552.448-1 1-1h2.841zm-29.71 64.526l4.426 1.593C20.335 68.802 19 72.245 19 76s1.335 7.198 3.557 9.88l-4.427 1.594C15.55 84.359 14 80.36 14 76s1.55-8.359 4.13-11.474z"
															/>
														</svg>
														<svg
															class="audio-icon-r1101"
															width="113"
															height="113"
															viewBox="0 0 113 113"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M71.0693 46.1333C71.0693 45.7028 70.8652 45.2978 70.519 45.0413C70.1728 44.7849 69.7254 44.7073 69.3129 44.8323L69.2462 44.8525L69.2403 44.833L48.3673 51.1769L48.3658 51.1777C47.7926 51.3519 47.4008 51.8799 47.4008 52.4783L47.4008 68.7931H41.9555C36.5923 68.7931 32.9504 76.2255 37.8166 81.0842C42.3121 85.5729 50.1235 82.2306 50.1235 76.0441L50.1235 53.4864L68.3467 47.9664L68.3467 64.2608H62.9013C57.5381 64.2608 53.8963 71.6932 58.7624 76.5519C63.2579 81.0406 71.0693 77.6983 71.0693 71.5118L71.0693 46.1333ZM62.9013 66.9799H68.3467L68.3467 71.5118C68.3467 75.2954 63.4539 77.3913 60.6874 74.629C57.4411 71.3876 60.0984 66.9799 62.9013 66.9799ZM41.9555 71.5122H47.4008V76.0441C47.4008 79.8277 42.508 81.9236 39.7416 79.1613C36.4953 75.9199 39.1526 71.5122 41.9555 71.5122Z"
																class="primary-svg-fill"
															/>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M3.55346 0C1.59094 0 0 1.59093 0 3.55346V109.447C0 111.409 1.59093 113 3.55346 113H109.447C111.409 113 113 111.409 113 109.447V3.55346C113 1.59094 111.409 0 109.447 0H3.55346ZM67.1205 36.6063C67.3336 36.9938 67.5192 37.3563 67.6791 37.6856C68.5934 37.2741 69.8179 36.8128 71.2555 36.4933C74.4691 35.7792 78.8339 35.7638 83.086 38.6886C86.9517 41.3477 88.5532 45.1055 89.1915 48.0973C89.5108 49.5943 89.5963 50.9265 89.6024 51.8878C89.6031 51.99 89.6028 52.0882 89.6019 52.1822C89.6683 52.2138 89.7371 52.2468 89.8082 52.2812C90.6283 52.6775 91.759 53.2589 93.009 54.0029C95.4672 55.4661 98.5596 57.6584 100.575 60.43C103.807 64.8737 104.697 72.1349 102.885 78.237C101.965 81.3328 100.318 84.254 97.7926 86.4107C95.2446 88.5868 91.8977 89.9009 87.7646 89.9009H27.0013C13.968 89.9009 7.37633 78.4319 7.82004 68.855C8.20488 60.5491 12.5856 55.3031 16.7959 52.1897C18.8908 50.6405 20.9543 49.6076 22.4928 48.961C22.9852 48.754 23.4263 48.5856 23.8004 48.4517C23.8147 48.028 23.8441 47.5201 23.8997 46.9445C24.0662 45.2204 24.4703 42.8611 25.4272 40.3254C27.3596 35.2049 31.544 29.4049 40.3415 26.7264C50.9918 23.4837 58.1283 26.5946 62.5513 30.6994C64.7176 32.7098 66.1903 34.9146 67.1205 36.6063Z"
																class="primary-svg-fill"
															/>
														</svg>
														<svg
															class="audio-icon-r1102"
															width="125"
															height="97"
															viewBox="0 0 125 97"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M104.469 52.3599C104.469 75.5943 85.6786 94.4295 62.5 94.4295C56.3723 94.4295 50.5513 93.113 45.3028 90.7467L24.3645 97L29.7958 78.7273C24.0007 71.5137 20.5314 62.3429 20.5314 52.3599C20.5314 29.1256 39.3214 10.2904 62.5 10.2904C85.6786 10.2904 104.469 29.1256 104.469 52.3599ZM49.5169 32.9898C49.5169 25.8022 55.3297 19.9755 62.5 19.9755C69.6703 19.9755 75.4831 25.8022 75.4831 32.9898V46.9121C75.4831 54.0996 69.6703 59.9264 62.5 59.9264C55.3297 59.9264 49.5169 54.0996 49.5169 46.9121V32.9898ZM43.1763 36.319C44.3434 36.319 45.2899 37.2675 45.2899 38.4376V47.5174C45.2899 57.0452 52.995 64.7689 62.5 64.7689C72.005 64.7689 79.7101 57.0452 79.7101 47.5174V38.4376C79.7101 37.2675 80.6566 36.319 81.8237 36.319C82.9907 36.319 83.9372 37.2675 83.9372 38.4376V47.5174C83.9372 58.6702 75.4613 67.839 64.6135 68.903V79.9019H70.9541C72.1211 79.9019 73.0676 80.8503 73.0676 82.0205C73.0676 83.1906 72.1211 84.1391 70.9541 84.1391H53.442C52.275 84.1391 51.3285 83.1906 51.3285 82.0205C51.3285 80.8503 52.275 79.9019 53.442 79.9019H59.7826V68.835C49.2262 67.4964 41.0628 58.4625 41.0628 47.5174V38.4376C41.0628 37.2675 42.0093 36.319 43.1763 36.319Z"
																fill="#21409A"
															/>
															<path
																d="M115.942 44.7935H115.786C111.48 19.3636 89.3967 0 62.8019 0C36.2071 0 14.1242 19.3636 9.81811 44.7935H9.05797C6.05634 44.7935 3.62319 47.2325 3.62319 50.2413V76.8753C3.62319 79.8841 6.05634 82.3231 9.05797 82.3231H13.8889C16.8905 82.3231 19.3237 79.8841 19.3237 76.8753V50.2413C19.3237 47.307 17.0091 44.9146 14.1106 44.7979C18.3648 21.7184 38.5465 4.23722 62.8019 4.23722C87.0556 4.23722 107.236 21.7163 111.492 44.7935H111.111C108.109 44.7935 105.676 47.2325 105.676 50.2413V76.8753C105.676 79.8841 108.109 82.3231 111.111 82.3231H115.942C118.944 82.3231 121.377 79.8841 121.377 76.8753V50.2413C121.377 47.2325 118.944 44.7935 115.942 44.7935Z"
																fill="#0E0606"
															/>
															<path
																d="M121.377 78.0431C123.425 77.7493 125 75.9836 125 73.8487V55.0839C125 52.949 123.425 51.1833 121.377 50.8895V78.0431Z"
																fill="#21409A"
															/>
															<path
																d="M3.62319 78.0429C1.5747 77.7492 0 75.9833 0 73.8486V55.0838C0 52.9492 1.5747 51.1832 3.62319 50.8895V78.0429Z"
																fill="#21409A"
															/>
														</svg>
													</div>
												</ng-container>
												<ng-container *ngIf="!isR11">
													<div class="audio-thumbnail">
														<svg
															class="audio-thumbnail-unselected"
															width="90px"
															height="98px"
															viewBox="0 0 90 98"
															version="1.1"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<path
																	class="secondary-svg-fill"
																	fill="#cccccc"
																	d="M70.265038,-1.98951966e-13 C82.5065659,12.9069993 89.5,30.3401707 89.5,48.9148779 C89.5,67.2602677 82.6781774,84.4921338 70.716025,97.3496556 L70.265038,97.8297558 L63.734962,91.6363636 C74.3950845,80.3967377 80.5,65.1784577 80.5,48.9148779 C80.5,32.8803626 74.5658429,17.8619094 64.1826745,6.67066551 L63.734962,6.19339216 L70.265038,-1.98951966e-13 Z M35.4427746,9.22224999 C35.8003326,9.59470616 36,10.0910083 36,10.6073137 L36,87.2224421 C36,88.3270116 35.1045695,89.2224421 34,89.2224421 C33.4836946,89.2224421 32.9873925,89.0227747 32.6149363,88.6652168 L11,67.9148779 L-1.13686838e-13,67.9148779 L-1.13686838e-13,29.9148779 L11,29.9148779 L32.6149363,9.16453901 C33.4117588,8.39958947 34.6778251,8.42542756 35.4427746,9.22224999 Z M56.265038,17.8181818 C64.0534672,26.030004 68.5,37.1142821 68.5,48.9148779 C68.5,60.5154636 64.2029198,71.4238078 56.6581744,79.5915587 L56.265038,80.011574 L49.734962,73.8181818 C55.9419858,67.273733 59.5,58.4043463 59.5,48.9148779 C59.5,39.6078992 56.0775167,30.8973824 50.090114,24.3917057 L49.734962,24.011574 L56.265038,17.8181818 Z M43.9099026,33.0049753 C48.0993194,37.1943922 50.5,42.8702386 50.5,48.9148779 C50.5,54.8084013 48.217853,60.3513408 44.2207454,64.5078046 L43.9099026,64.8247805 L37.5459415,58.4608194 C40.0642628,55.9424982 41.5,52.5480342 41.5,48.9148779 C41.5,45.4070028 40.161572,42.1216424 37.8025813,39.6325516 L37.5459415,39.3689364 L43.9099026,33.0049753 Z"
																></path>
															</g>
														</svg>
													</div>
												</ng-container>
											</ng-template>
										</div>
										<!--		Audio Creatives Ends Here			-->
									</div>
								</ng-template>
							</ngx-carousel-3d-slide>
						</ngx-carousel-3d>
						<div [class]="badgeClass">
							<p
								class="pills"
								*ngIf="sortedCreatives[selectedIndex]?.isIAB && !sortedCreatives[selectedIndex]?.isNative"
							>
								Display
							</p>
							<p
								class="pills"
								*ngIf="sortedCreatives[selectedIndex]?.isNative && !sortedCreatives[selectedIndex]?.isIAB"
							>
								Native
							</p>
							<p
								class="pillsBoth"
								*ngIf="sortedCreatives[selectedIndex]?.isNative && sortedCreatives[selectedIndex]?.isIAB"
							>
								Display with Native
							</p>
						</div>
						<ul
							class="carousel-points-container-r5 myPoint"
							[ngClass]="{
								'carousel-points-container-r5-Video': isVideoCreative || isAudioCreative,
								'carousel-points-container-r5-sem': sectionclass == 'ovrwSemCreatives'
							}"
							*ngIf="graphData"
						>
							<li
								[ngClass]="{ 'highlight-light': i === selectedIndex }"
								*ngFor="let j of carousel.$slides; let i = index"
							></li>
						</ul>

						<span
							(click)="slideRight()"
							class="u-cursor-pointer u-cursor-pointer-right"
							*ngIf="sortedCreatives?.length > 1"
						>
							<img
								*ngIf="!isR11"
								src="../../../../../assets/creative-assets/right_arrow.svg"
								[class]="arrowRightClass"
							/>
							<div *ngIf="isR11" [class]="arrowRightClass">
								<img style="position: relative; left: 35%" src="../../../../../assets/images/right_arrow.png" />
							</div>
						</span>
						<!-- starting vedio status div  -->
						<div
							class="video-status video-stats-tv"
							[id]="videoStatusBar"
							*ngIf="currentCreativeData?.showStats"
							[ngClass]="{ 'video-stats-social': isSocial }"
						>
							<div class="preroll-creative-table_svg_content">
								<div
									(click)="circleVideoClickEvent(0)"
									[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
									class="drawCircle"
									id="svg_0Percent"
								></div>
								<div class="horizontalLine"></div>
								<span
									id="percent0"
									style="margin-top: -40px !important"
									class="preRoll-creative-footer-content-started started"
									>Started</span
								>
								<span class="preRoll-creative-footer-content" *ngIf="currentCreativeData?.percentValue25 != null">
									<span class="percentageValue primary-color postion_100">100%</span>
								</span>
							</div>
							<div class="preroll-creative-table_svg_content">
								<div
									(click)="circleVideoClickEvent(25)"
									[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
									class="drawCircle"
									id="svg_25Percent"
								></div>
								<div class="horizontalLine"></div>
								<span id="percent25" class="preRoll-creative-footer-content-label started">
									<p style="text-align: center">25%</p>
									<p>Complete</p>
								</span>
								<span class="preRoll-creative-footer-content" *ngIf="currentCreativeData?.percentValue25 != null">
									<span class="percentageValue primary-color"
										>{{ currentCreativeData?.percentRate25 | number : '1.2-2' }}%</span
									>
									<span style="margin-left: 0.5em" class="viewNumber"
										>{{ currentCreativeData?.percentValue25 | number : '1.0-2' }}
										Views
									</span>
								</span>
							</div>
							<div class="preroll-creative-table_svg_content">
								<div
									(click)="circleVideoClickEvent(50)"
									[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
									class="drawCircle"
									id="svg_50Percent"
								></div>
								<div class="horizontalLine"></div>
								<span id="percent50" class="preRoll-creative-footer-content-label">
									<p style="text-align: center">50%</p>
									<p>Complete</p></span
								>

								<span class="preRoll-creative-footer-content" *ngIf="currentCreativeData?.percentValue50 != null">
									<span class="percentageValue primary-color"
										>{{ currentCreativeData?.percentRate50 | number : '1.2-2' }}%</span
									>
									<span style="margin-left: 0.5em" class="viewNumber"
										>{{ currentCreativeData?.percentValue50 | number : '1.0-2' }}
										Views
									</span>
								</span>
							</div>
							<div class="preroll-creative-table_svg_content">
								<div
									(click)="circleVideoClickEvent(75)"
									[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
									class="drawCircle"
									id="svg_75Percent"
								></div>
								<div class="horizontalLine"></div>
								<span id="percent75" class="preRoll-creative-footer-content-label">
									<p style="text-align: center">75%</p>
									<p>Complete</p></span
								>

								<span class="preRoll-creative-footer-content" *ngIf="currentCreativeData?.percentValue75 != null">
									<span class="percentageValue primary-color"
										>{{ currentCreativeData?.percentRate75 | number : '1.2-2' }}%</span
									>
									<span style="margin-left: 0.5em" class="viewNumber"
										>{{ currentCreativeData?.percentValue75 | number : '1.0-2' }}
										Views
									</span>
								</span>
							</div>
							<div class="preroll-creative-table_svg_content">
								<div
									(click)="circleVideoClickEvent(100)"
									[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
									class="drawCircle"
									id="svg_100Percent"
								></div>
								<span id="percent100" class="preRoll-creative-footer-content-label">
									<p style="text-align: center">100%</p>
									<p>Complete</p></span
								>

								<span class="preRoll-creative-footer-content" *ngIf="currentCreativeData?.percentValue100 != null">
									<span style="margin-left: -0.7em" class="percentageValue primary-color"
										>{{ currentCreativeData?.percentRate100 | number : '1.2-2' }}%</span
									>
									<span style="margin-left: 0.5em" class="viewNumber"
										>{{ currentCreativeData?.percentValue100 | number : '1.0-2' }}
										Views
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="performance-graph-area" *ngIf="graphData">
					<app-creative-r5-graph
						[legendData]="legend"
						[enableLabels]="false"
						[sectiontitle]="sectiontitle"
						[chartConfig]="barChartDataConfiguration"
						[tooltipOption]="{ customToolTip: true }"
						[graphData]="graphData"
						[name]="'creative_' + key"
						(legendSelected)="processSelectedLegendItem($event)"
						(mouseOutChart)="chartHover($event)"
						(mouseOverChart)="chartHover($event)"
					></app-creative-r5-graph>
				</div>

				<div class="analytics-portlet-content_r7" *ngIf="hasData"></div>

				<div class="parameters-div" *ngIf="!graphData">
					<div *ngFor="let stat of currentStats; let i = index" class="stats-div">
						<div class="row">
							<div class="stat-param-name display-stats">{{ stat.name }}</div>
							<div class="param-percent display-stats">
								<span *ngIf="stat.hasPercent && !isR9">
									{{ stat.percent_value }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; |</span
								>
								<span *ngIf="stat.hasPercent && isR9"> {{ stat.percent_value }} |</span>
							</div>
							<div class="stat-param-val display-stats">
								<span *ngIf="stat?.value">{{ stat?.value | formatNumber }} {{ stat.addPer ? '%' : '' }} </span
								><span *ngIf="!stat?.value">--</span>
							</div>

							<div class="stat-param-toggle">
								<a
									href="javascript:void(0)"
									title="Expand/Collapse Row"
									(click)="expandRow(stat)"
									class="expander"
									*ngIf="stat.isExpandable"
								>
									<i class="fa fa-angle-right" aria-hidden="true" *ngIf="!stat.expand"></i>
									<i class="fa fa-angle-down" aria-hidden="true" *ngIf="stat.expand"></i>
								</a>
							</div>
						</div>

						<div *ngIf="stat.expand && stat.isExpandable && stat.valuesForExpandables" class="parameters-div">
							<div *ngFor="let detailMetrics of stat.valuesForExpandables; let j = index" class="stats-div">
								<div class="row-for-details">
									<div class="stat-param-name stat-weight-normal display-stats">
										{{ detailMetrics.engagementName }}
									</div>
									<div class="stat-param-val stat-weight-normal display-stats">
										<span *ngIf="detailMetrics?.engagementValue"
											>{{ detailMetrics?.engagementValue | formatNumber }}
										</span>
										<span *ngIf="!detailMetrics?.engagementValue">--</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-modal id="custom-modal-creative-preview" *ngIf="selectedCreative">
		<div class="modal">
			<div class="modal-body">
				<div class="displayModelBody" [ngClass]="{ 'social-modal': selectedCreative?.isSocial }">
					<div class="modal-header">
						<div class="creative-name">
							{{ selectedCreative?.creativeName }}
							<div class="close-button" (click)="closeModal('custom-modal-creative-preview')">
								<i class="fa fa-times-circle"></i>
							</div>
						</div>
					</div>
					<div class="modal-content">
						<div *ngIf="!selectedCreative?.iframeUrl">
							<app-creative-ad-preview
								[creative]="selectedCreative"
								(modalClose)="closeModal('custom-modal-creative-preview')"
								*ngIf="selectedCreative?.hasAdSizes || selectedCreative?.native?.url; else noAdSizePreviewBlock"
							>
							</app-creative-ad-preview>
							<ng-template #noAdSizePreviewBlock>
								<div style="font-size: 1.6em; padding: 30px 20px">No different adsizes available for preview.</div>
							</ng-template>
						</div>
						<div *ngIf="selectedCreative?.iframeUrl">
							<div
								class="social-iframe-container"
								*ngIf="selectedCreative?.isIframeExpired == 0"
								[innerHtml]="selectedCreative?.iframeUrl | safeUrl : false"
							></div>
							<div class="social-iframe-container" *ngIf="selectedCreative?.isIframeExpired == 1">
								<div *ngIf="selectedCreative?.hasSnapshotImage" class="social-iframe-container">
									<img [src]="selectedCreative?.snapshotImage" />
								</div>
								<div *ngIf="!selectedCreative?.hasSnapshotImage" class="social-iframe-container">
									<img src="../../../../../assets/images/iframe_ad_not_available.png" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-background"></div>
	</app-modal>
</div>
